export enum Languages {
  EN = 'en',
  ES = 'es',
  RU = 'ru',
}
// TODO-ekvasiuk we can remove this variable when the whole translation done
export const LOCALIZATION_ENABLED = !!process.env.LOCALIZATION_ENABLED;
